import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { Row, Col } from 'antd';

class Part4 extends React.PureComponent {
  getDelay = (e, b) => (e % b) * 100 + Math.floor(e / b) * 100 + b * 100;

  render() {
    const { ...tagProps } = this.props;
    const { dataSource,isMobile } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    const children = dataSource.block.children.map((item, i) => {
      const childObj = item.children;
      const delay = isMobile ? i * 50 : this.getDelay(i, 24 / item.md);
      const liAnim = {
        opacity: 0,
        type: 'from',
        ease: 'easeOutQuad',
        delay,
      };
    let clearFloatNum = 0;

      const childrenAnim = { ...liAnim, x: '+=10', delay: delay + 100 };
      clearFloatNum += item.md;
      clearFloatNum = clearFloatNum > 24 ? 0 : clearFloatNum;
      return (
        <TweenOne
          component={Col}
          animation={liAnim}
          key={item.name}
          {...item}
          componentProps={{ md: item.md, xs: item.xs }}
          className={
            !clearFloatNum
              ? `${item.className || ''} clear-both`.trim()
              : item.className
          }
        >



          <TweenOne
            animation={{
              x: '-=10',
              opacity: 0,
              type: 'from',
              ease: 'easeOutQuad',
            }}
            key="img"
            {...childObj.icon}
          >
            <img src={childObj.icon.children} width="100%" alt="img" />
          </TweenOne>
          <div {...childObj.textWrapper}>
            <TweenOne
              key="h2"
              animation={childrenAnim}
              component="h2"
              {...childObj.title}
            >
              {childObj.title.children}
            </TweenOne>
          </div>
        </TweenOne>
      );
    });


    return (
      <div {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.title}>
            {dataSource.title.children}
          </div>
          
          <OverPack {...dataSource.OverPack}>
            <QueueAnim key="u" type="bottom">
              <Row key="row" {...dataSource.block}>
                {children}
              </Row>
            </QueueAnim>
          </OverPack>

          <QueueAnim
            key="QueueAnim"
            type={['bottom', 'top']}
            delay={200}
          >
            <div key="content" {...dataSource.content}>
              <span className='content-title'>
                可明CSAR合规辅助软件 
              </span>
              <span>
              {(
                dataSource.content.children
              )}
              </span>
            </div>

          </QueueAnim>
        </div>
      </div>
    );
  }
}
export default Part4;
